// extracted by mini-css-extract-plugin
export default {"root":"Q72kZXL0pzcEESy4jhzw","check":"ul9tniDryPOuZj8PKx9D"};